import React, { useState } from 'react';

const PlayerCard = ({ player }) => {
  const [expanded, setExpanded] = useState(false);

  const ratingColor = () => {
    if (player.rating >= 96) return '#ff4d4d';
    if (player.rating >= 90) return '#ff8c00';
    if (player.rating >= 85) return '#ffd200';
    if (player.rating >= 80) return '#4caf50';
    return '#8888aa';
  };

  const tierLabel = () => {
    if (player.rating >= 96) return 'Franchise';
    if (player.rating >= 90) return 'Lottery';
    if (player.rating >= 85) return 'First Round';
    if (player.rating >= 80) return 'Second Round';
    return 'Prospect';
  };

  return (
    <div className={`player-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(!expanded)}>
      <div className="card-header">
        <div className="rank-section">
          <div className="rating-circle" style={{ borderColor: ratingColor() }}>
            <span className="rating-num" style={{ color: ratingColor() }}>
              {player.rating > 0 ? player.rating.toFixed(0) : 'NR'}
            </span>
          </div>
        </div>

        <div className="player-info">
          <div className="player-name-row">
            {player.jersey_number && (
              <span className="jersey-num">#{player.jersey_number}</span>
            )}
            <h3 className="player-name">{player.name}</h3>
          </div>
          <div className="player-meta">
            <span className="position-tag">{player.position}</span>
            <span className="separator">|</span>
            <span>{player.height || 'N/A'}</span>
            <span className="separator">|</span>
            <span>{player.weight || 'N/A'}</span>
          </div>
          <div className="player-meta secondary">
            <span>{player.school || 'No School'}</span>
            <span className="separator">|</span>
            <span className="class-badge">Class of {player.class_year}</span>
          </div>
        </div>

        <div className="tier-section">
          <span className="tier-badge" style={{ background: ratingColor() }}>
            {tierLabel()}
          </span>
        </div>
      </div>

      {expanded && (
        <div className="card-details">
          {player.hometown && (
            <div className="detail-row">
              <span className="detail-label">Hometown:</span>
              <span>{player.hometown}</span>
            </div>
          )}
          {player.college && (
            <div className="detail-row">
              <span className="detail-label">Commitment:</span>
              <span>{player.college}</span>
            </div>
          )}
          {player.nba_comparison && (
            <div className="detail-row">
              <span className="detail-label">NBA Comp:</span>
              <span>{player.nba_comparison}</span>
            </div>
          )}
          {player.strengths && (
            <div className="detail-block">
              <span className="detail-label">Strengths:</span>
              <p>{player.strengths}</p>
            </div>
          )}
          {player.weaknesses && (
            <div className="detail-block">
              <span className="detail-label">Weaknesses:</span>
              <p>{player.weaknesses}</p>
            </div>
          )}
          {player.scouting_report && (
            <div className="detail-block">
              <span className="detail-label">Scouting Report:</span>
              <p>{player.scouting_report}</p>
            </div>
          )}
        </div>
      )}

      <style>{`
        .player-card {
          background: #1a1a2e;
          border: 1px solid #2a2a4a;
          border-radius: 12px;
          padding: 16px;
          cursor: pointer;
          transition: all 0.2s;
        }
        .player-card:hover {
          border-color: #3a3a5a;
          transform: translateY(-1px);
          box-shadow: 0 4px 20px rgba(0,0,0,0.3);
        }
        .player-card.expanded {
          border-color: #f7971e;
          grid-column: 1 / -1;
        }
        .card-header {
          display: flex;
          align-items: center;
          gap: 14px;
        }
        .rating-circle {
          width: 52px;
          height: 52px;
          border-radius: 50%;
          border: 3px solid;
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
        }
        .rating-num {
          font-size: 1.2rem;
          font-weight: 800;
        }
        .player-info { flex: 1; min-width: 0; }
        .player-name-row {
          display: flex;
          align-items: center;
          gap: 8px;
        }
        .jersey-num {
          color: #f7971e;
          font-weight: 700;
          font-size: 0.85rem;
        }
        .player-name {
          font-size: 1.05rem;
          font-weight: 700;
          color: #fff;
        }
        .player-meta {
          display: flex;
          align-items: center;
          gap: 6px;
          font-size: 0.8rem;
          color: #8888aa;
          margin-top: 3px;
        }
        .player-meta.secondary { margin-top: 2px; }
        .position-tag {
          background: #2a2a4a;
          padding: 2px 8px;
          border-radius: 8px;
          color: #ccccee;
          font-weight: 600;
        }
        .separator { color: #3a3a5a; }
        .class-badge {
          color: #f7971e;
          font-weight: 600;
        }
        .tier-section { flex-shrink: 0; }
        .tier-badge {
          padding: 4px 12px;
          border-radius: 12px;
          font-size: 0.7rem;
          font-weight: 700;
          color: #1a1a2e;
          white-space: nowrap;
        }
        .card-details {
          margin-top: 16px;
          padding-top: 14px;
          border-top: 1px solid #2a2a4a;
          display: grid;
          gap: 10px;
        }
        .detail-row {
          display: flex;
          gap: 8px;
          font-size: 0.85rem;
        }
        .detail-label {
          color: #8888aa;
          font-weight: 600;
          min-width: 110px;
        }
        .detail-block p {
          margin-top: 4px;
          color: #bbb;
          font-size: 0.85rem;
          line-height: 1.5;
        }
      `}</style>
    </div>
  );
};

export default PlayerCard;
